import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    facebook: {},
    hasToken: false,
    business: {},
    selected: [],
    reloadPosts: false
  },
  mutations: {
    SET_Facebook(state, facebook) {
      state.facebook = facebook;
      state.hasToken = true;
    },
    SET_Selection(state, selected) {
      state.selected = selected;
    },
    ADD_Selection(state, id) {
      state.selected.push(id);
    },
    REMOVE_Selection(state, id) {
      state.selected.splice(state.selected.indexOf(id), 1);
    },
    CLEAR_Selection(state) {
      state.selected = [];
    },
    SET_Business(state, business) {
      state.business = business;
    },
    RELOAD_Posts(state, val) {
      state.reloadPosts = val;
    },
    Logout(state) {
      state.facebook = {};
      state.hasToken = false;
    },
    updateField
  },
  actions: {
    setFacebook: ({ commit }, facebook) => {
      if (facebook.hasOwnProperty('authResponse')) {
        commit("SET_Facebook", facebook);
      }
    },
    setBusiness: ({ commit }, business) => {
      commit("SET_Business", business);
    },
    setReloadPosts: ({ commit }, val) => {
      commit("RELOAD_Posts", val);
    },
    addSelection: ({ commit }, id) => {
      commit("ADD_Selection", id);
    },
    setSelection: ({ commit }, selected) => {
      commit("SET_Selection", selected);
    },
    clearSelection: ({ commit }) => {
      commit("CLEAR_Selection");
    },
    removeSelection: ({ commit }, id) => {
      commit("REMOVE_Selection", id);
    },
    logout: ({ commit }) => {
      commit("Logout");
    },
  },
  getters: {
    facebook: (state) => {
      return state.facebook;
    },
    hasToken: (state) => {
      return state.hasToken;
    },
    business: (state) => {
      return state.business;
    },
    selected: (state) => {
      return state.selected;
    },
    reloadPosts: (state) => {
      return state.reloadPosts;
    },
    getField
  },
  modules: {
  },
  plugins: [createPersistedState()],
})
